import { Mail, MapPin, Phone } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=6716+N+50th+Ave,+Omaha,+NE+68152";

export default function ContactSection() {
  return (
    <section id="contact" className="relative scroll-mt-24 overflow-hidden py-24 sm:py-32">
      <div
        aria-hidden
        className="absolute left-1/2 top-1/2 h-[36rem] w-[36rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-cobalt/15 blur-[140px]"
      />
      <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-cobalt">
            Get in touch
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-[clamp(2.8rem,7vw,6rem)] font-extrabold uppercase leading-[0.92]">
            Let&rsquo;s move
            <br />
            <span className="text-cobalt">your freight.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/65 sm:text-lg">
            Shippers and brokers — one call gets you a straight answer on
            availability and rates.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-4 md:grid-cols-5">
          <Reveal delay={0.1} className="md:col-span-3">
            <a
              href="tel:+14026391139"
              data-testid="contact-call-tile"
              className="group flex h-full items-center justify-between gap-6 border border-white/10 bg-panel/60 p-8 transition-all duration-300 hover:border-cobalt hover:bg-cobalt/10 sm:p-10"
            >
              <div>
                <p className="font-mono text-xs uppercase tracking-[0.25em] text-white/50">
                  Call us — fastest
                </p>
                <p className="mt-3 font-display text-4xl font-bold sm:text-5xl">
                  402-639-1139
                </p>
              </div>
              <span className="grid h-14 w-14 shrink-0 place-items-center rounded-full bg-cobalt transition-transform duration-300 group-hover:scale-110">
                <Phone className="h-6 w-6" />
              </span>
            </a>
          </Reveal>

          <Reveal delay={0.18} className="md:col-span-2">
            <a
              href="mailto:Zakilogistics.ne@gmail.com"
              data-testid="contact-email-tile"
              className="group flex h-full items-center justify-between gap-6 border border-white/10 bg-panel/60 p-8 transition-all duration-300 hover:border-cobalt hover:bg-cobalt/10 sm:p-10"
            >
              <div className="min-w-0">
                <p className="font-mono text-xs uppercase tracking-[0.25em] text-white/50">
                  Email
                </p>
                <p className="mt-3 break-all text-lg font-semibold sm:text-xl">
                  Zakilogistics.ne@gmail.com
                </p>
              </div>
              <span className="grid h-14 w-14 shrink-0 place-items-center rounded-full border border-white/20 transition-transform duration-300 group-hover:scale-110">
                <Mail className="h-6 w-6" />
              </span>
            </a>
          </Reveal>

          <Reveal delay={0.26} className="md:col-span-5">
            <a
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-directions-tile"
              className="group flex flex-wrap items-center justify-between gap-6 border border-white/10 bg-panel/60 p-8 transition-all duration-300 hover:border-cobalt hover:bg-cobalt/10"
            >
              <div className="flex items-center gap-5">
                <span className="grid h-12 w-12 place-items-center rounded-full border border-white/20">
                  <MapPin className="h-5 w-5 text-cobalt" />
                </span>
                <div>
                  <p className="font-mono text-xs uppercase tracking-[0.25em] text-white/50">
                    Yard &amp; office
                  </p>
                  <p className="mt-2 text-lg font-semibold">
                    6716 N 50th Ave, Omaha, NE 68152
                  </p>
                </div>
              </div>
              <span className="font-mono text-xs uppercase tracking-[0.25em] text-cobalt transition-transform duration-300 group-hover:-translate-y-0.5">
                Get directions →
              </span>
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
